import DropDownTypes from './dropdown.types';

 
export const toggleDropDownHidden = (payload) => ({
    type: DropDownTypes.TOGGLE_DROPDOWN_HIDDEN,
    payload:payload
});


